import {
  StripeAddressElement,
  StripeAddressElementChangeEvent,
  StripeElements,
  StripePaymentElementChangeEvent,
} from '@stripe/stripe-js';
import { Injectable, inject } from '@angular/core';
import { StripeService } from '../../../../core/services/stripe.service';
import { LanguageService } from '../../../../core/services/language.service';
import { TypePaymentMethod } from '../models';
import { PaymentDataService } from './payment-data.service';

@Injectable({ providedIn: 'root' })
export class StripeUiService {
  private readonly stripeService = inject(StripeService);
  private readonly languageService = inject(LanguageService);
  private readonly paymentDataService = inject(PaymentDataService);

  onlinePaymentElements: StripeElements | null;
  addressElement: StripeAddressElement | null;
  addressElementInvoice: StripeAddressElement | null;

  isPaymentElementComplete = false;
  isAddressElementComplete = false;
  isAddressElementInvoiceComplete = false;

  paymentElementId = 'online-payment-element';
  paymentAddressElementId: 'online-address-element';
  paymentAddressElementInvoiceId: 'invoice-address-element';

  async init(selectedMethod: TypePaymentMethod) {
    const activeLang = this.languageService.getActiveLanguage();
    if (selectedMethod === 'online') {
      this.onlinePaymentElements =
        await this.stripeService.createElements(activeLang);
      if (!this.onlinePaymentElements) {
        return;
      }
      this.mountPaymentElement(
        this.onlinePaymentElements,
        this.paymentElementId,
        (event) => {
          this.isPaymentElementComplete = event.complete;
          this.paymentDataService.selectedOnlinePaymentType.set(
            event.value.type,
          );
        },
      );
      this.addressElement = this.mountAddressElement(
        this.onlinePaymentElements,
        this.paymentAddressElementId,
        (event) => {
          this.isAddressElementComplete = event.complete;
          this.paymentDataService.selectedCountry.set(
            event.value.address.country,
          );
        },
      );
    } else {
      const invoiceAddressElements =
        await this.stripeService.createElements(activeLang);
      if (!invoiceAddressElements) {
        return;
      }
      this.addressElementInvoice = this.mountAddressElement(
        invoiceAddressElements,
        this.paymentAddressElementInvoiceId,
        (event) => {
          this.isAddressElementInvoiceComplete = event.complete;
          this.paymentDataService.selectedCountry.set(
            event.value.address.country,
          );
        },
      );
    }
  }

  mountPaymentElement(
    elements: StripeElements,
    id: string,
    onChange: (event: StripePaymentElementChangeEvent) => void,
  ): void {
    const paymentElement = this.stripeService.createPaymentElement(elements);
    paymentElement.mount(`#${id}`);
    paymentElement.on('change', onChange);
  }

  mountAddressElement(
    elements: StripeElements,
    id: string,
    onChange: (event: StripeAddressElementChangeEvent) => void,
  ) {
    const addressElement = this.stripeService.createAddressElement(elements);
    addressElement.mount(`#${id}`);
    addressElement.on('change', onChange);
    return addressElement;
  }
}
